<template>
  <generic-container
    :title="$t('modules')"
    icon="chess"
    :searchable="true"
    v-on:filter="filter"
    :header_buttons="header_buttons"
    :header_menus="header_menus"
    :show_plus="true"
    @add="add_module"
  >
    <cards-view
      :modules="modules"
      :hide_unused="hide_unused"
      v-if="view == 'cards'"
      @deactivate="deactivate"
      @activate="activate"
      @configure="configure"
    />
    <list-view
      :modules="modules"
      :hide_unused="hide_unused"
      v-if="view == 'list'"
      @deactivate="deactivate"
      @activate="activate"
      @configure="configure"
    />
    <table-view
      :modules="modules"
      :hide_unused="hide_unused"
      v-if="view == 'table'"
      @deactivate="deactivate"
      @activate="activate"
      @configure="configure"
    />
    <template v-for="(mdl, index) in configure_modals">
      <component
        :is="mdl"
        :key="index"
        @destroy="destroy_configure_modals"
      ></component>
    </template>
    <module-modal ref="module_modal" />
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { local_api, toast } from "@/utils";
import TableView from "./TableView.vue";
import CardsView from "./CardsView.vue";
import ListView from "./ListView.vue";
import ModuleModal from "./module_modal/Index";

var loadConfigurationComponent = (component) => {
  return new Promise(function(resolve, reject) {
    let x = import("@/modules/" + component + ".vue");
    x.then((r) => {
      resolve(r);
    }).catch((err) => {
      reject(err);
    });
  });
};

export default {
  data() {
    return {
      modules: [],
      all_modules: [],
      configure_modals: [],
      component_name: "",
      header_buttons: [
        {
          icon: this.hide_unused ? "eye" : "unhide",
          tooltip: this.$t("toggle unused"),
          click: this.toggle_unused,
        },
      ],
      header_menus: [
        {
          tooltip: this.$t("format code"),
          icon: "spa",
          buttons: [
            {
              icon: "grip horizontal",
              text: this.$t("cards"),
              click: () => {
                this.view = "cards";
              },
            },
            {
              icon: "list",
              text: this.$t("list"),
              click: () => {
                this.view = "list";
              },
            },
            {
              icon: "table",
              text: this.$t("table"),
              click: () => {
                this.view = "table";
              },
            },
          ],
        },
      ],
      view: "cards",
      hide_unused: true,
    };
  },
  components: {
    "generic-container": GenericContainer,
    TableView,
    CardsView,
    ListView,
    ModuleModal,
  },
  methods: {
    // import_component() {
    //   return new Promise(function(resolve, reject) {
    //     if (this.component_name) {
    //       let x = loadConfigurationComponent(this.component_name);
    //       return x;
    //     }
    //   });
    // },
    filter(value) {
      let vm = this;
      if (value == "") vm.modules = vm.all_modules;
      else
        vm.modules = vm.all_modules.filter((n) => {
          let submdls = vm.submodules(n);
          if (!submdls || !submdls.length) submdls = [];
          let vlu = value.toUpperCase();
          return (
            vm
              .$t(n.setup.name)
              .toUpperCase()
              .includes(vlu) ||
            vm
              .$t(n.setup.description)
              .toUpperCase()
              .includes(vlu) ||
            submdls.find((s) => {
              return (
                vm
                  .$t(s.setup.name)
                  .toUpperCase()
                  .includes(vlu) ||
                vm
                  .$t(s.setup.description)
                  .toUpperCase()
                  .includes(vlu)
              );
            })
          );
        });
    },
    activate(module) {
      let vm = this;
      local_api(this, "post", "/user_module_suscription/do-suscribe", {
        i: module.module_id,
      })
        .then((suscription) => {
          module.usr_module_suscriptions.push(suscription);
        })
        .catch((err) => {
          toast(vm.$el, "error", err);
        });
    },
    deactivate(module) {
      let vm = this;
      local_api(this, "post", "/user_module_suscription/do-unsuscribe", {
        i: module.usr_module_suscriptions[0].suscription_id,
      })
        .then(() => {
          module.usr_module_suscriptions = [];
        })
        .catch((err) => {
          toast(vm.$el, "error", err);
        });
    },
    configure(module) {
      let vm = this;
      vm.component_name = module.setup.configure_component;
      vm.configure_modals = [];
      loadConfigurationComponent(vm.component_name)
        .then((comp) => {
          vm.configure_modals.push(comp.default);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    toggle_view() {
      if (this.view == "cards") this.view = "list";
      else if (this.view == "list") this.view = "cards";
    },
    submodules(module) {
      let subm = this.all_modules.filter((m) => {
        return (
          m.setup &&
          m.setup.parent_modules &&
          m.setup.parent_modules.includes(module.setup.name)
        );
      });
      return subm;
    },
    destroy_configure_modals() {
      this.configure_modals = [];
      // console.log("sdfsdf");
      // window
      //   .jQuery(".ui.dimmer.modals.page")
      //   .removeClass(["visible", "active"])
      //   .addClass("hidden");
    },
    toggle_unused() {
      this.hide_unused = !this.hide_unused;
    },
    add_module() {
      let vm = this;
      vm.$refs.module_modal.show_modal();
    },
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/system/do-get-modules", {})
      .then((response) => {
        if (response) {
          this.modules = this.all_modules = response.sort(function(a, b) {
            if (vm.$t(a.setup.name) > vm.$t(b.setup.name)) {
              return 1;
            }
            if (vm.$t(a.setup.name) < vm.$t(b.setup.name)) {
              return -1;
            }
            return 0;
          });
        }

        setTimeout(() => {
          window.jQuery(".ui.help.button").popup({ on: "click" });
        }, 200);
      })
      .catch((err) => {
        toast(vm.$el, "error", err);
      })
      .finally(() => {
        this.processing = false;
      });
  },
};
</script>

<style>
.deactivated {
  background-color: #eee !important;
}
</style>
